import type { RHContractDuration } from "../../models/ProcurementModels"


export const RHContractDurationLimits = Object.freeze({
    minimumMonths: 1,
    minimumDays: 1
})


type RHContractDurationValidationContext = {
    isRequired: boolean
    partLabel: string
}


export class RHContractDurationValidator {

    static validationMessageForContractDuration(
        contractDuration: RHContractDuration | undefined,
        context: RHContractDurationValidationContext
    ): string | undefined {
        if (!contractDuration) {
            if (context.isRequired) {
                return `${context.partLabel} peab olema määratud lepingu kestus.`
            }
            return undefined
        }
        if (contractDuration.type === "specifiedInDocs") {
            return undefined
        }
        if (contractDuration.type === "durationInMonths") {
            if (!RHContractDurationValidator._isIntegerAtLeast(
                contractDuration.months,
                RHContractDurationLimits.minimumMonths
            )) {
                return `${context.partLabel} peab välja „Kestus kuudes” väärtus olema täisarv ja vähemalt 1.`
            }
            return undefined
        }
        if (contractDuration.type === "durationInDays") {
            if (!RHContractDurationValidator._isIntegerAtLeast(
                contractDuration.days,
                RHContractDurationLimits.minimumDays
            )) {
                return `${context.partLabel} peab välja „Kestus päevades” väärtus olema täisarv ja vähemalt 1.`
            }
            return undefined
        }
        if (contractDuration.type === "dateRange") {
            if (
                contractDuration.startDate !== undefined &&
                contractDuration.startDate !== null &&
                !RHContractDurationValidator._isValidDate(contractDuration.startDate)
            ) {
                return `${context.partLabel} lepingu kestuse alguskuupäev ei ole korrektne.`
            }
            if (!RHContractDurationValidator._isValidDate(contractDuration.endDate)) {
                return `${context.partLabel} peab olema määratud lepingu kestuse lõppkuupäev.`
            }
            return undefined
        }
        return `${context.partLabel} lepingu kestuse liik ei ole korrektne.`
    }


        static _isIntegerAtLeast(value: number | undefined, minimumValue: number): boolean {
        return typeof value === "number" &&
            Number.isInteger(value) &&
            value >= minimumValue
    }


        static _isValidDate(value: Date | string | number | null | undefined): boolean {
        if (typeof value === "string" || typeof value === "number" || value instanceof Date) {
            return Boolean(value) && !Number.isNaN(new Date(value).getTime())
        }
        return false
    }
}
